import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleStreetwear } from '@/mocks/articles';

export default function StreetwearGuidePage() {
  return <ArticleLayout article={articleStreetwear} />;
}